import React, { Component, useState } from "react";
import "./QBOPullCatalogItemsModal.scss";
import OwButton from "../../../shared/OwButton/OwButton";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwDateInput from "../../../shared/OwDateInput/OwDateInput";
import { Moment } from "moment-timezone";
import OwCheckbox from "../../../shared/OwCheckbox/OwCheckbox";

type Props = {
    closeModalFn: () => void;
    startPullFn: (lastPullTime?: string, pullCategories?: boolean, rePullImages?: boolean) => void;
};

export const QBOPullCatalogItemsModal: React.FC<Props> = (props) => {
    const [dateStr, setDateStr] = useState<string>();
    const [pullCategories, setPullCategories] = useState<boolean>(false);
    const [repullImages, setRepullImages] = useState<boolean>(false);

    const closeModal = () => {
        props.closeModalFn();
    };

    const start = () => {
        props.startPullFn(dateStr, pullCategories, repullImages);
    };

    const handleLastUpdatedAt = (date: Moment) => {
        setDateStr(date.format("YYYY-MM-DD"));
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        if (name === "pull_categories") {
            setPullCategories(!!value);
        }

        if (name === "repull_images") {
            setRepullImages(!!value);
        }
    };

    return (
        <div className={"QBOPullCatalogItemsModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <div>
                        <OwTitle leftIconName={"fad fa-cloud-download-alt"} title={"quickbooks_online"} tag={"h3"} />
                        <OwTitle title={"pull_catalog_items"} tag={"h5"} />
                    </div>
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            <div className={"mt-2"}>
                <div>
                    <OwLabel title={"from_last_updated_at"} />
                    <OwDateInput fn={handleLastUpdatedAt} />
                </div>
            </div>

            <div className="mt-2">
                <OwCheckbox
                    name={"pull_categories"}
                    fn={handleChange}
                    truthyVal={true}
                    falsyVal={false}
                    checked={pullCategories}
                    label={"pull_categories"}
                />
            </div>

            <div className="mt-2">
                <OwCheckbox
                    name={"repull_images"}
                    fn={handleChange}
                    truthyVal={true}
                    falsyVal={false}
                    checked={repullImages}
                    label={"repull_images"}
                />
            </div>

            <div className="mt-2">
                <OwButton title={"start"} fn={start} />
            </div>
        </div>
    );
};
